import { Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  height: 100vh;
  background: #f6f6f6;
`;

export const Content = styled(Flex).attrs({
  vertical: true,
  align: 'center',
  gap: 24,
})`
  width: 100%;
  max-width: 418px;
  padding: 24px;
  .ant-input-outlined {
    border-radius: 8px !important;
  }
  .ant-form-item-required {
    &:before {
      display: none !important;
    }
  }
`;

export const Welcome = styled.p`
  padding: 0;
  margin: -8px 0 0;
  color: ${(props) => props.theme.antd.colorPrimary};
  font-size: 26px;
  font-weight: 500;
`;

export const FormCard = styled.div`
  min-width: 320px;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.25);
  background: #fff;
`;

export const ExtraActions = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})`
  height: 32px;
`;

export const ChangePasswordContainer = styled(Flex).attrs({ vertical: true })`
  width: 100%;
  max-width: 1248px;
  margin: 0 auto;
  @media (max-width: 1288px) {
    margin: 0 20px;
  }
`;
